module.exports = __webpack_public_path__ + "img/Gif3.e020f75a.gif";